import { get } from "../../service/api";

const GetSubMerchants = async (merchantId) => {
  try {
    const response = await get(`/admin/subMerchant/dropdown?merchantId=${merchantId}`);
    return response;
  } catch (error) {
    console.error("Error GetSubMerchants:", error);
    throw error;
  }
};

export default GetSubMerchants;
